/* Package JSON Import will be here */
import React, { useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Modal, Button, Input, Form } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { bulkOrderUpload } from "reducers/orders"
import TooltipComp from "components/reusable/TooltipComp";
/* Project Import will be here */

const BulkOrderModal = (props) => {
    const [isShowBulkOrderModal, setIsShowBulkOrderModal] = useState(false);

    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));

    const dispatch = useDispatch();

    const showOrHideBulkOrderUploadModal = () => {
        setIsShowBulkOrderModal(!isShowBulkOrderModal);
    }

    const submitQty = (values) => {
        const splittedSubCat = props.subCat.split("_");
        const subCatId = splittedSubCat[splittedSubCat.length - 1];

        dispatch(bulkOrderUpload(values.qty, subCatId));

        /* Close bulk upload modal */
        showOrHideBulkOrderUploadModal();
    }

    return (
        <React.Fragment>
            <Col flex="none" className="text-center pb-1 pl-2 pr-2">
                <TooltipComp title={translate("order.bulkOrderUpload.label")}>
                    <i onClick={showOrHideBulkOrderUploadModal} className="fa fa-upload fa-lg" aria-hidden="true"></i>
                </TooltipComp>
            </Col>

            {isShowBulkOrderModal &&
                <Modal
                    title={translate("order.bulkOrderUpload.label")}
                    width={450}
                    centered
                    maskClosable={false}
                    visible={isShowBulkOrderModal}
                    onCancel={showOrHideBulkOrderUploadModal}
                    className="bulk-upload-modal"
                    closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                    footer={[
                        <Button size="large" key="cancel" onClick={showOrHideBulkOrderUploadModal}>
                            {translate("common.buttons.cancel")}
                        </Button>,
                        <Button
                            key="ok"
                            htmlType="submit"
                            size="large"
                            form="bulkOrderQtyModal"
                            type="primary">
                            {translate("common.buttons.addToCart")}
                        </Button>
                    ]}
                >
                    <React.Fragment>
                        <div className="p-2 responsive-font-size text-center">
                            {translate("order.bulkOrderUpload.message", { count: props.count })}
                        </div>

                        <Form
                            name="bulkOrderQtyModal"
                            onFinish={submitQty}
                            layout="vertical"
                        >
                            <Row justify="center" className="p-2">
                                <Col span={12}>
                                    <Form.Item
                                        name="qty"
                                        rules={[{ required: true, pattern: /^[1-9][0-9]*$/, message: translate("order.bulkOrderUpload.validationMsg") }]}
                                    >
                                        <Input
                                            className="round-radius text-center"
                                            inputMode="numeric"
                                            maxLength={4}
                                            placeholder={translate("products.productLabel.enterQty")}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </React.Fragment>
                </Modal>
            }
        </React.Fragment>
    );
};

export default BulkOrderModal;